export default __webpack_public_path__ + "static/jan6-d61171b3fdaf09da821dbfa3c819bc9d.gif";